<template>
  <div class="sale-detail">
    <sale-info class="sale-info-1" :sale="sale" />
    <div class="sale-info-2">
      <div class="sale-name">{{ sale.saleName }}</div>
      <div class="sale-content">{{ sale.content }}</div>
    </div>
    <div class="sale-info-3">
      <div>
        <table>
          <tbody>
            <tr>
              <td class="">募集期間</td>
              <td class="">{{ formatDate(sale.applicationPeriodFrom, sale.applicationPeriodTo) }}</td>
            </tr>
            <tr>
              <td class="">開催期間</td>
              <td class="">{{ formatDate(sale.eventPeriodFrom, sale.eventPeriodTo) }}</td>
            </tr>
            <tr>
              <td class="">参加条件</td>
              <td>{{ sale.target }}</td>
            </tr>
          </tbody>
        </table>
        <div class="text-gray">セールID：{{ sale.saleId }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import SaleInfo from './SaleInfo'
import moment from 'moment'
import 'moment/locale/ja'

export default {
  components: {
    SaleInfo
  },
  props: {
    sale: {
      type: Object
    }
  },
  created () {
    moment.locale('ja')
  },
  methods: {
    getEntryStatus (sale) {
      if (sale.hasEntry) {
        return 'エントリー済み'
      }

      return '未エントリー'
    },
    calcDeadline (applicationPeriodTo) {
      const endDate = moment(applicationPeriodTo)
      const now = moment()
      const diffDays = endDate.diff(now, 'days')
      const diffMinutes = endDate.diff(now, 'minutes')
      if (endDate.isBefore(now)) return 0
      return diffMinutes > 0 ? diffDays + 1 : diffDays
    },
    formatDate (from, to) {
      if (!from || !to) {
        return '・・・'
      }
      const fromDate = moment(from).format('M月D日 HH:mm:ss')
      const toDate = moment(to).format('M月D日 HH:mm:ss')
      return `${fromDate} ～ ${toDate}`
    }
  }
}
</script>
<style scoped>
.text-gray {
  color: #666;
}
.sale-detail {
  display: grid;
  grid-template-columns: 250px 1fr;
  max-width: 100%;
  gap: 10px;
}
.sale-info-1 {
  grid-row: span 2 / span 2;
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.sale-info-3 {
  grid-column-start: 2;
  grid-row-start: 2;
  display: flex;
  flex-direction: column;
  justify-content: end;
  table {
    width: 100%;
    max-width: 500px;
    td {
      padding: 3px 5px;
      border: 1px solid #ccc;
    }
    tr td:first-child {
      font-weight: bold;
      width: 100px;
      background-color: #ccc;
    }
    tr:nth-child(2) td:first-child {
      border-bottom-color: #fff;
      border-top-color: #fff;
    }
    tr:first-child td:first-child {
      border-bottom-color: #fff;
    }
  }
}
.tag {
  flex: 0.5;
  border: 1px solid #ccc;
  text-align: center;
  padding: 5px;
  font-weight: bold;
  background-color: #fff;
  max-height: 32px;
}
.sale-banner {
  width: 100%;
  max-height: 150px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.sale-name {
  color: #008cc6;
  font-size: 24px;
  font-weight: 600;
  border-bottom: 3px solid rgb(27, 172, 74);
}
.sale-content {
  margin-top: 10px;
}
.recommend {
  background-color: red;
  color: #fff;
  border-color: red;
}
.has-entry {
  background-color: #aaa;
  color: #fff;
}
.mall {
  color: #fff;
}
.premium {
  border-color: #bf9000;
  color: #bf9000;
}
.deadline {
  color: red;
  border-color: red;
}
@media (max-width: 767px) {
  .sale-info-1,
  .sale-info-2,
  .sale-info-3 {
    grid-column: 1 / -1;
  }

  .sale-info-1 {
    grid-row: 1;
  }

  .sale-info-2 {
    grid-row: 2;
  }

  .sale-info-3 {
    grid-row: 3;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/sale/components/SaleDetail.vue